import React from "react";
import { Button } from "reactstrap";
import notifications from "../../common/Components/Notifications/Notification";

type ShareAccessPasswordOnceProps = {
  password: string;
  emailed?: boolean;
};

const ShareAccessPasswordOnce: React.FC<ShareAccessPasswordOnceProps> = ({
  password,
  emailed,
}) => {
  if (!password) return null;

  const copyPassword = () => {
    navigator.clipboard?.writeText(password).catch(() => {});
    notifications({
      title: "Copied",
      message: "Access password copied. It will not be shown again after you leave this screen.",
      type: "success",
    });
  };

  return (
    <div className="hkp-share-password-once" role="status">
      <p className="hkp-share-password-once-label">Access password — shown only once</p>
      <code className="hkp-share-password-once-value">{password}</code>
      <Button
        color="primary"
        className="hkp-share-password-once-copy"
        onClick={copyPassword}
        style={{ backgroundColor: "#0071E3", borderColor: "#0071E3" }}
      >
        Copy password
      </Button>
      <p className="hkp-share-password-once-hint">
        {emailed
          ? "This password was emailed with the invite. Copy it now in case the client asks."
          : "Copy this password and send it with the link. It will not appear in the share-link list later."}
      </p>
    </div>
  );
};

export default ShareAccessPasswordOnce;
